import { scorePopupStyle, scoreTextStyle, sharkMessageStyle } from './styles';

interface ScorePopupProps {
  score: number;
  isShark: boolean;
}

export const ScorePopup = ({ score, isShark }: ScorePopupProps) => {
  return (
    <div css={scorePopupStyle(isShark)}>
      {isShark ? (
        <>
          <span css={sharkMessageStyle}>저는 왜요 ㅠㅠ</span>
          <span css={scoreTextStyle(isShark)}>
            {score > 0 ? '+' : ''}
            {score}
          </span>
        </>
      ) : (
        <span css={scoreTextStyle(isShark)}>
          {score > 0 ? '+' : ''}
          {score}
        </span>
      )}
    </div>
  );
};
